import I9_EXT_1 from "./I9_EXT_1";
export default {
  I9_EXT_1,
};
